import { render, staticRenderFns } from "./MessageAudio.vue?vue&type=template&id=6d23a2c6&scoped=true&"
import script from "./MessageAudio.vue?vue&type=script&lang=js&"
export * from "./MessageAudio.vue?vue&type=script&lang=js&"
import style0 from "./MessageAudio.vue?vue&type=style&index=0&id=6d23a2c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d23a2c6",
  null
  
)

export default component.exports